export default __webpack_public_path__ + "static/drivethru_2-018f3dce6c5a6b3603256cf0b83984dc.png";